import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../../components/ui/dialog';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../../components/ui/table';
import { FileText } from 'lucide-react';

const formatCurrency = (value) => {
  if (value === null || value === undefined) return '$0';
  return new Intl.NumberFormat('es-CL', { style: 'currency', currency: 'CLP', minimumFractionDigits: 0 }).format(value);
};

const formatFecha = (f) => {
  const s = String(f || '').trim();
  if (!s) return '-';
  return s.includes('T') ? s.slice(0, 10) : s.split(' ')[0];
};

// Iter 294.a: modal compartido entre Informe Costo OT e Informe por Proyecto
export const FacturasEmitidasModal = ({ ot, onClose }) => (
  <Dialog open={!!ot} onOpenChange={(open) => !open && onClose()}>
    <DialogContent className="max-w-4xl max-h-[85vh] overflow-y-auto" data-testid="modal-facturas-emitidas">
      <DialogHeader>
        <DialogTitle className="flex items-center gap-2">
          <FileText className="w-5 h-5 text-blue-600" />
          Facturas emitidas · OT-{ot?.numero_ot}
        </DialogTitle>
        <p className="text-xs text-muted-foreground">
          {ot?.proyecto_codigo && <span className="font-mono">{ot.proyecto_codigo} · </span>}
          {ot?.descripcion}
        </p>
      </DialogHeader>
      {ot && (
        <div className="space-y-2">
          <div className="text-xs bg-blue-50 dark:bg-blue-950/50 rounded p-2 grid grid-cols-3 gap-2">
            <div><span className="text-muted-foreground">Total facturas:</span> <strong>{ot.real.cantFacturas}</strong></div>
            <div><span className="text-muted-foreground">Facturado (neto):</span> <strong className="text-blue-700">{formatCurrency(ot.real.facturado)}</strong></div>
            <div><span className="text-muted-foreground">Total Gastos:</span> <strong className="text-slate-700">{formatCurrency(ot.real.totalGastos)}</strong></div>
          </div>
          <Table>
            <TableHeader>
              <TableRow className="text-xs bg-muted/50">
                <TableHead className="py-1">N° Factura</TableHead>
                <TableHead className="py-1">Fecha</TableHead>
                <TableHead className="py-1 text-right">Neto</TableHead>
                <TableHead className="py-1 text-right">IVA</TableHead>
                <TableHead className="py-1 text-right">Total</TableHead>
                <TableHead className="py-1">Estado</TableHead>
                <TableHead className="py-1">Cond. Pago</TableHead>
                <TableHead className="py-1">OC Cliente</TableHead>
                <TableHead className="py-1">HES</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {(ot.real.ventasList || []).length === 0 ? (
                <TableRow>
                  <TableCell colSpan={9} className="text-center text-muted-foreground py-3">
                    Sin facturas registradas
                  </TableCell>
                </TableRow>
              ) : (ot.real.ventasList || [])
                .slice()
                .sort((a, b) => String(b.fecha_emision || b.fecha || '').localeCompare(String(a.fecha_emision || a.fecha || '')))
                .map((v, i) => {
                  const cancel = v.cancelado === 1 || v.cancelado === true || v.cancelado === '1';
                  return (
                    <TableRow key={`fac-${v.id_venta || v.numero_factura}-${i}`} className={`text-xs ${cancel ? 'line-through opacity-60' : ''}`}>
                      <TableCell className="font-mono">{String(v.numero_factura || '').replace(/\.0$/, '')}</TableCell>
                      <TableCell>{formatFecha(v.fecha_emision || v.fecha)}</TableCell>
                      <TableCell className="text-right font-mono">{formatCurrency(v.neto)}</TableCell>
                      <TableCell className="text-right font-mono text-muted-foreground">{formatCurrency(v.iva)}</TableCell>
                      <TableCell className="text-right font-mono font-semibold">{formatCurrency(v.total)}</TableCell>
                      <TableCell>
                        {cancel ? (
                          <span className="text-red-600 font-semibold">Anulada</span>
                        ) : (
                          <span className="text-emerald-700">{v.estado || 'Emitida'}</span>
                        )}
                      </TableCell>
                      <TableCell className="text-[11px] text-muted-foreground">{v.condicion_pago || '-'}</TableCell>
                      <TableCell className="text-[11px] font-mono">{v.orden_compra || '-'}</TableCell>
                      <TableCell className="text-[11px] font-mono">{v.hes || '-'}</TableCell>
                    </TableRow>
                  );
                })}
            </TableBody>
          </Table>
        </div>
      )}
    </DialogContent>
  </Dialog>
);

export default FacturasEmitidasModal;
